import React, { useState, useEffect, useRef } from "react";
import Navbar from "../Common/Navbar";
import SideMenu from "../Common/SideMenu";
import ProfileIcon from "../../assets/icons/profile";
import NotificationIcon from "../../assets/icons/notification";
import { LayoutContext } from "../AdminModule/LayoutContext";
import { getPermissions } from "../../Utils/auth";
import { getAllowedRoutes } from "../../Utils/getAllowedRoutes";

const Layout = ({ children }) => {
  const layoutRef = useRef(null);
  const permissions = getPermissions();
  const allowedRoutes = getAllowedRoutes(permissions);
  const [isOpen, setIsOpen] = useState(true);
  const [user, setUser] = useState(null);

  console.log("user", user);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    setUser(JSON.parse(userData));
  }, []);

  let menuItems = [];

  allowedRoutes.forEach((route) => {
    if (route.menuItem) {
      menuItems.push({
        path: route.path,
        label: route.label,
        Icon: route.Icon,
        menuOrder: route.menuOrder,
      });
    }
  });

  // add static items
  menuItems.push(
    { path: "/profile", label: "Profile", Icon: ProfileIcon, menuOrder: 9998 },
    {
      path: "/notifications",
      label: "Notifications",
      Icon: NotificationIcon,
      menuOrder: 9999,
    }
  );

  // sort by menuOrder
  menuItems.sort((a, b) => a.menuOrder - b.menuOrder);

  return (
    <LayoutContext.Provider
      value={{ userData: user ? user : null, layoutRef: layoutRef }}
    >
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <div
          className={`fixed top-[88px] left-0 h-[calc(100%-88px)] bg-white border-r border-[#142b701a] transition-all duration-300 z-40
  ${isOpen ? "translate-x-0" : "-translate-x-full"} w-64 md:translate-x-0`}
        >
          <SideMenu menuItems={menuItems} />
        </div>

        {/* Main content */}
        <div className="flex flex-col flex-1 w-full">
          <div className="fixed top-0 left-0 right-0 z-40">
            <Navbar toggleSidebar={() => setIsOpen(!isOpen)} user={user} />
          </div>

          {/* Push content below navbar */}
          <main
            className={`mt-[88px] transition-all duration-300 p-6 bg-[#f9f9f9] min-h-[calc(100vh-88px)] overflow-y-scroll ${
              isOpen ? "md:ml-64" : "md:ml-16"
            }`}
            ref={layoutRef}
          >
            {children}
          </main>
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;
